import { action, makeObservable } from 'mobx';
import { Store } from '../../../store/store';
import { StoreNode, Message } from '../../../store';
import { WindowState } from '../../../components/overlays/windowState';

export class PostRegistrationTutorialState
  extends StoreNode {
  readonly nodeType = 'PostRegistrationTutorialWindow';
  constructor(store: Store, props?: Record<string, unknown>) {
    super(store, props);
    makeObservable(this, {
      open: action,
      close: action,
    });
    this.window.listen(
      this.windowListener);
  }

  private windowListener = (msg: Message<WindowState>) => {
    switch (msg.type) {
      case 'close':
      case 'outsideClick':
        this.close();
        break;
    }
  }

  readonly window = new WindowState(this.store);

  open() {
    this.dispatch('Overlays', 'openWindow', { name: 'PostRegistrationTutorialWindow' });
  }

  close() {
    this.dispatch('Overlays', 'closeWindow');
  }
}